define('v3/Pages/Check/Components/CheckClassGrid/Services/checkClassGrid.Service',[
	'jquery',
	'lodash',
	'v3/Pages/Check/Services/Check.Service',
	'v3/Pages/Check/Components/CheckClassGrid/Services/checkClassGrid.Backend',
	'v3/Common/Services/Backend/pupilBackend',
	'v3/Pages/Check/Components/CheckClassGrid/ViewModels/CheckClass.ViewModel'
], function ($, _, checkService, checkClassBackend, pupilBackend, CheckClassViewModel) {
	function CheckClassGridService () {
		var self = this;

		self.getPupilsWithStatistics = function (subjectGroupId, period, usePupilAverageGrowth) {
			var _abilityGrowthDeferred = getAbilityGrowthDeferred(subjectGroupId, period, usePupilAverageGrowth);
			var _subjectPercentileDeferred = checkClassBackend.getSubjectCurrentPercentileForPupilsInSubjectGroup(subjectGroupId);
			var _subjectTargetPercentileDeferred = checkClassBackend.UserSubjectTargetPercentileForSubjectGroup(subjectGroupId);
			var _pupilsDeferred = pupilBackend.getSubjectGroupPupilNamesForSorting(subjectGroupId);

			return $.when(_pupilsDeferred, _abilityGrowthDeferred, _subjectPercentileDeferred, _subjectTargetPercentileDeferred)
				.then(function (pupils, pupilsAbilityGrowth, subjectPercentileModel, subjectTargetPercentile) {
					var pupilModels = _.map(pupils, function (pupil) {
						var pupilModel = new CheckClassViewModel(pupil,
							subjectPercentileModel[pupil.pupilId],
							subjectTargetPercentile[pupil.pupilId]);

						if (pupilsAbilityGrowth) {
							var pupilAbilityGrowth = usePupilAverageGrowth ? _.find(pupilsAbilityGrowth, { 'pupilId': pupil.pupilId })
								: pupilsAbilityGrowth[pupil.pupilId];

							if (pupilAbilityGrowth) {
								pupilModel.updatePupilAbilityGrowth(pupilAbilityGrowth);
							}
						}
						return pupilModel;
					});

					return checkService.NormalizeAbilityGrowthInClass(pupilModels);
				});
		};

		self.fillPupilsWithAbilityGrowth = function (pupilsArray, subjectGroupId, period, usePupilAverageGrowth) {
			return checkClassBackend.getAbilityGrowthForSubjectGroup(subjectGroupId, period, usePupilAverageGrowth)
				.then(function (pupilsAbilityGrowth) {
					_.forEach(pupilsArray, function (pupilModel) {
						var pupilAbilityGrowth = null;

						if (usePupilAverageGrowth) {
							pupilAbilityGrowth = _.find(pupilsAbilityGrowth, { 'pupilId': pupilModel.pupilId }) || { score: 0 };
						} else {
							pupilAbilityGrowth = pupilsAbilityGrowth[pupilModel.pupilId] || { abilityGrowth: 0, targetAbilityGrowth: 0 };
						}

						pupilModel.updatePupilAbilityGrowth(pupilAbilityGrowth);
					});

					return checkService.NormalizeAbilityGrowthInClass(pupilsArray);
				});
		};

		self.getPupilsReportData = function (subjectGroupId, includeSubdomains) {
			if (!includeSubdomains) {
				return checkClassBackend.getSubjectGroupAbilityHistory(subjectGroupId);
			}

			return $.when(
				checkClassBackend.getSubjectGroupAbilityHistory(subjectGroupId),
				checkClassBackend.getSubdomainsWithBoundaryPercentileForPupils(subjectGroupId),
				checkClassBackend.getNumberOfExtraInstructionsForSubdomainsForPupils(subjectGroupId)
			);
		};

		self.generateReport = function (html) {
			return checkClassBackend.generateReport(html);
		};

		function getAbilityGrowthDeferred (subjectGroupId, period, usePupilAverageGrowth) {
			if (usePupilAverageGrowth) {
				// whether the request to the Metrics API for getting data succeeds or fails the deferred
				// shouldn't be rejected but always return a valid result, so that the other calls that are being
				// made to retrieve data still continue
				var deferred = $.Deferred();

				checkClassBackend
					.getAbilityGrowthForSubjectGroup(subjectGroupId, period, usePupilAverageGrowth)
					.always(function (data, status) {
						var result = status === 'error' ? null : data;

						return deferred.resolve(result);
					});

				return deferred;
			} else {
				return checkClassBackend.getAbilityGrowthForSubjectGroup(subjectGroupId, period, usePupilAverageGrowth);
			}
		}
	}
	return new CheckClassGridService();
});
